/* eslint-disable react/prop-types */
import {
	Alert,
	Button,
	Grid,
	Input,
	InputLabel,
	Snackbar,
	Typography,
	TextField,
	OutlinedInput,
	Modal,
	Box,
	IconButton,
	InputAdornment,
	Select,
	MenuItem,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import React from 'react';

import { Link } from 'react-router-dom';

import { addPayer, getPayerById } from '../../../../services/api/apiManager';

import { useState, useEffect } from 'react';

import CancelIcon from '@mui/icons-material/Cancel';

import * as Yup from 'yup';
import { Call } from '@mui/icons-material';
import MaskedInput from 'react-text-mask';
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '55%',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	borderRadius: '12px',
};

function Addpayer(props) {
	const defaultTheme = createTheme();

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	const [openModal, setOpenModal] = useState(true);
	// Close Modal
	const handleCloseModal = () => {
		setOpenModal(false);
		// this prop sending data to my parent component so whenever i close my modal ViewPayer Component will be shown
		props.renderHandleFromChild('insurrance');
	};
	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
	};
	const handleEmptyFieldError = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setEmptyFieldError(false);
	};
	const id = localStorage.practice_id;

	// const handleNameChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, Name: input }));
	// 	}
	//   };
	// const handleTypeChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, Type: input }));
	// 	}
	//   };
	// const handleCityChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, City: input }));
	// 	}
	//   };
	// const handleStateChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, State: input }));
	// 	}
	//   };

	const schema = Yup.object().shape({
		Name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Type: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Type should contain only alphabets'),
		// City: Yup.string().matches(
		// 	/^[a-zA-Z\s]+$/,
		// 	'City Name should contain only alphabets'
		// ),
		// State: Yup.string().matches(
		// 	/^[a-zA-Z]+$/,
		// 	'State Name should contain only alphabets'
		// ),
		// Contact: Yup.string().matches(
		// 	/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
		// 	'Invalid '
		// ),
		// Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});

	//   const handleKeyPress = (e) => {
	// 	const charCode = e.which ? e.which : e.keyCode;
	// 	if (
	// 	  charCode !== 32 && // allow space
	// 	  !(charCode >= 65 && charCode <= 90) && // allow uppercase letters
	// 	  !(charCode >= 97 && charCode <= 122) // allow lowercase letters
	// 	) {
	// 	  e.preventDefault();
	// 	}
	//   };

	const [payer, setPayer] = useState({
		Name: '',
		practice_id: id,
		Type: '',
		Contact: '',
		Address: '',
		City: '',
		State: '',
		Zip: '',
		Comments: '',
	});
	const addPayerData = async () => {
		try {
			// if (Object.values(payer).some((value) => value === '')) {
			// 	setEmptyFieldError(true);
			// 	return; // Exit function if any field is empty
			// }
			if (!payer?.Name || !payer?.Type) {
				setEmptyFieldError(true);
				return;
			}
			await schema.validate(payer, { abortEarly: false });

			const response = await addPayer(payer);
			if (response?.status === 201) {
				setPayer(true);
				setOpenSnackbar(true);
				handleCloseModal();
				// this props is sending data to parent for opening modal
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'green',
					snakbarFor: 'payer',
				});

				// setPayer(response?.data);
			} else if (response?.status === 400) {
				setOpenSnackbarError(true);
				handleCloseModal();
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'red',
					snakbarFor: 'payer',
				});
			} else {
				setOpenSnackbarError(true);
				handleCloseModal();
			}
		} catch (error) {
			console.error('Error updating user:', error);
		}
	};

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setPayer((prev) => ({
			...prev,
			[name]: value,
		}));
		if (name === 'Name' || name === 'Type') {
			Yup.reach(schema, name)
				.validate(value)
				.then(() => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: '', // Clear error if validation passes
					}));
				})
				.catch((error) => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: error.message, // Set error message if validation fails
					}));
				});
		}
	};

	// const fetchPayer = async () => {
	// 	try {
	// 		debugger
	// 		const response = await getPayerById();
	// 		if (response?.status === 200) {
	// 			setPayer(response?.data);
	// 		}
	// 		else
	// 		{
	// 			setPayer({});
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching payer:', error);
	// 	}
	// };

	// const updatePayer = async () => {
	// 	try {
	// 		const response = await updatePayer(user);
	// 		if (response?.status === 200) {
	// 			setPayer(response?.data);
	// 		}
	// 		else
	// 		{
	// 			setPayer({});
	// 		}
	// 	} catch (error) {
	// 		console.error('Error updating user:', error);
	// 	}
	// };

	// useEffect(()=>{
	// 	fetchPayer();
	// },[])

	return (
		<ThemeProvider theme={defaultTheme}>
			{/* Darks code Start from here  */}
			{/* Modal Structure */}
			<Modal
				open={openModal}
				// onClose={handleCloseModal} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={style}>
					<Grid
						item
						lg={12}
						xs={12}
						md={12}
						sm={12}
						xl={12}
						justifyContent="center"
					>
						<Box
							sx={{
								width: '100%',
								height: '65px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								sx={{
									width: '88%',
									fontFamily: 'Poppins',
									fontSize: '32px',
									fontWeight: 500,
									textAlign: 'center',
								}}
							>
								Add Payer
							</Typography>
							<IconButton onClick={handleCloseModal}>
								<CancelIcon sx={{ fontSize: '30px' }} color="error" />
							</IconButton>
						</Box>
					</Grid>
					<Grid container lg={12} xs={12} md={12} sm={12} p={3}>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Payer Name <span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								// value={location?.Name}
								// onChange={(e) =>
								// 	setLocation((prev) => ({ ...prev, Name: e.target.value }))
								// }
								name="Name"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={payer?.Name}
								error={emptyField && payer?.Name == ''}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Name && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Name}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Payer Type<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<Select
								error={emptyField && payer?.Type == ''}
								name="Type"
								size="small"
								fullWidth
								displayEmpty
								inputProps={{ padding: '2px' }}
								value={payer?.Type}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							>
								<MenuItem value={'private'}>Private</MenuItem>
								<MenuItem value={'government'}>Government</MenuItem>
							</Select>
							{errors.Type && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Type}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Contact
								{/* <span style={{ color: '#d61b1b' }}>*</span> */}
							</InputLabel>
							<MaskedInput
								required
								name="Contact"
								value={payer?.Contact}
								onChange={handleInputChange}
								mask={[
									'(',
									/\d/,
									/\d/,
									/\d/,
									')',
									' ',
									/\d/,
									/\d/,
									/\d/,
									'-',
									/\d/,
									/\d/,
									/\d/,
									/\d/,
								]}
								style={{
									width: '100%',
									borderRadius: '6px',
									height: '40px',
									marginBottom: '8px',
									// marginTop: '8px',
									// border: `${emptyField && payer?.Contact == '' ? '1px solid #d61b1b' : '1.5px solid #DDE6F1'}`,
									border: `${'1.5px solid #DDE6F1'}`,
									padding: '5px 0px 5px 6px',
									outlineColor: '#f3a765',
									boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
								}}
							/>
							{errors.Contact && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Contact}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Address
							</InputLabel>
							<TextField
								// value={location?.Address}
								// onChange={(e) =>
								// 	setLocation((prev) => ({
								// 		...prev,
								// 		Address: e.target.value,
								// 	}))
								// }
								name="Address"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={payer?.Address}
								onChange={(e) =>
									setPayer((prev) => ({ ...prev, Address: e.target.value }))
								}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								City
								{/* <span style={{ color: '#d61b1b' }}>*</span> */}
							</InputLabel>
							<TextField
								// value={location?.City}
								// onChange={(e) =>
								// 	setLocation((prev) => ({ ...prev, City: e.target.value }))
								// }
								// error={emptyField && payer?.City == ''}
								name="City"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={payer?.City}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.City && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.City}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								State
								{/* <span style={{ color: '#d61b1b' }}>*</span> */}
							</InputLabel>
							<TextField
								// value={location?.State}
								// onChange={(e) =>
								// 	setLocation((prev) => ({
								// 		...prev,
								// 		State: e.target.value,
								// 	}))
								// }
								// error={emptyField && payer?.State == ''}
								name="State"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={payer?.State}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.State && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.State}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								ZIP
								{/* <span style={{ color: '#d61b1b' }}>*</span> */}
							</InputLabel>
							<TextField
								// value={location?.Zip}
								// onChange={(e) =>
								// 	setLocation((prev) => ({ ...prev, Zip: e.target.value }))
								// }
								// error={emptyField && payer?.Zip == ''}
								name="Zip"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={payer?.Zip}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Zip && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Zip}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Comments
							</InputLabel>
							<TextField
								// value={location?.Type}
								// onChange={(e) =>
								// 	setLocation((prev) => ({ ...prev, Type: e.target.value }))
								// }
								name="Comments"
								type="text"
								fullWidth
								disableUnderline
								value={payer?.Comments}
								onChange={(e) =>
									setPayer((prev) => ({ ...prev, Comments: e.target.value }))
								}
								sx={{
									'& input': {
										height: '23px',
									},
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
						</Grid>
					</Grid>
					<Box
						mt={1}
						width={'100%'}
						height={'70px'}
						display={'flex'}
						justifyContent={'center'}
						gap={2}
					>
						<Button
							onClick={handleCloseModal}
							style={{
								backgroundColor: '#ED2828',
								width: '151px',
								height: '52px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '20px',
							}}
						>
							Cancel
						</Button>
						<Button
							style={{
								backgroundColor: '#00A2E8',
								width: '151px',
								height: '52px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '20px',
							}}
							onClick={() => addPayerData()}
						>
							Add
						</Button>
					</Box>
				</Box>
			</Modal>
			{/* Darks code ends here */}

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity="success"
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					New Payer Added Successfully
				</Alert>
			</Snackbar>
			{/* snack bar for 401 error  */}
			<Snackbar
				open={openSnackbarError}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '17px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Error
				</Alert>
			</Snackbar>

			{/* snack bar for empty field  */}

			<Snackbar
				open={emptyField}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleEmptyFieldError}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleEmptyFieldError}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '14px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Fill all the Fields
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default Addpayer;
